/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState } from "react";

export interface ICartBadgeButtonProps {
  count?: number;
  onClick: () => void;
  style?: React.CSSProperties;
  className?: string;
}

export const CartBadgeButton: React.FC<ICartBadgeButtonProps> = ({
  count = 0,
  onClick,
  style,
  className,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      type="button"
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      title="View Cart"
      aria-label={`View Cart (${count} item${count === 1 ? "" : "s"})`}
      className={className}
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "48px",
        height: "48px",
        backgroundColor: isHovered ? "#F3F4F6" : "#FFFFFF",
        border: "none",
        borderRadius: "50%",
        padding: "0",
        cursor: "pointer",
        color: "#000000",
        outline: "none",
        boxShadow: isHovered
          ? "0 4px 12px rgba(0, 0, 0, 0.25)"
          : "0 2px 6px rgba(0, 0, 0, 0.15)",
        transition: "all 0.2s ease-in-out",
        transform: isHovered ? "scale(1.08)" : "scale(1)",
        ...style,
      }}
    >
      {/* Shopping Cart Icon */}
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="#000000"
        style={{
          display: "block",
        }}
      >
        <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
      </svg>

      {/* Cart Item Count Badge */}
      {count > 0 && (
        <span
          style={{
            position: "absolute",
            top: "-2px",
            right: "-2px",
            backgroundColor: "#2563EB",
            color: "#FFFFFF",
            borderRadius: "9999px",
            minWidth: "20px",
            height: "20px",
            padding: "0 5px",
            fontSize: "12px",
            fontWeight: "700",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: "1",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
            border: "2px solid #FFFFFF",
            pointerEvents: "none",
            userSelect: "none",
          }}
        >
          {count}
        </span>
      )}
    </button>
  );
};
